<template>
    <div
        v-if="selectedCategories.length"
        class="mb-4 flex flex-wrap gap-2 md:mx-4"
    >
        <template v-for="(category, index) in selectedCategories">
            <div
                v-if="index < maxVisibleSelectedCategories || showAll"
                class="border-b-1 flex items-center gap-4 rounded-full border border-gray-325 px-4 py-2 text-[16px] text-gray-700"
            >
                <div class="">
                    {{ category.title }}
                </div>
                <div
                    class="hover:cursor-pointer"
                    @click="deselectCategory(category.id)"
                >
                    <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M13.5 4.5L4.5 13.5"
                            stroke="#5D6375"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                        <path
                            d="M4.5 4.5L13.5 13.5"
                            stroke="#5D6375"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </div>
            </div>
        </template>
        <div
            class="lg:border-b-1 flex items-center px-4 py-2 text-[16px] text-primary-525 hover:cursor-pointer hover:text-primary-600"
            v-if="selectedCategories.length > maxVisibleSelectedCategories"
        >
            <span v-if="!showAll" @click="showAll = true"
                >See all (+
                {{
                    selectedCategories.length - maxVisibleSelectedCategories
                }})</span
            >
            <span v-else @click="showAll = false">Hide</span>
        </div>
    </div>
</template>
<script>
export default {
    name: "StudentSelectedCategoriesList",
    emits: ["remove-category"],
    props: {
        maxVisibleSelectedCategories: {
            type: Number,
            default: 5,
        },
        selectedCategories: {},
    },
    data() {
        return {
            showAll: false,
        };
    },
    methods: {
        deselectCategory(categoryId) {
            console.log(categoryId);
            this.$emit("remove-category", categoryId);
        },
    },
};
</script>
